import UserPasswordEditStep from './UserPasswordEditStep';

export default UserPasswordEditStep;
